module.exports = __webpack_public_path__ + "img/cmp-version-option-expand.7eeae009.svg";